import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App/App';
import { loadOneTrustScripts, setLangAttribute } from './App/App.helpers';

const container = document.getElementById('root');
const root = createRoot(container!);

setLangAttribute();
loadOneTrustScripts();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
